import React from 'react';
import styled from 'styled-components';

const Element = styled.div`
  padding: 8px 16px;
  border-radius: 8px;
  background: rgba(244, 241, 222, 0.05);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(244, 241, 222, 0.1);
`;

// Usando parâmetros padrão do JavaScript ao invés de defaultProps
const Box = ({ children, style = undefined }) => (
  <Element style={style}>{children}</Element>
);

export default Box;
